import React, { useRef, useState } from 'react';
import Header from '../components/HeaderWL';
import Footer from '../components/FooterWL';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import FooterWL from '../components/FooterWL';




function HomeGalleryWL() {

    const carouselRef = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0);

    const items = [
        {
            text: 'Showcase your art online and in virtual galleries.',
            imageSrc: 'images/carousel/crs-3.jpg',
            title: '1',
            by: 'Nicholas Daniels',
            alt: 'Hot Lava',
        },
        {
            text: 'Connect locally and globally.',
            imageSrc: 'images/items/anim-5.webp',
            title: '2t',
            by: 'Lori Hart',
            alt: 'Loop Donut',
        },
        {
            text: 'Share directly with collectors and enthusiasts.',
            imageSrc: 'images/carousel/crs-12.jpg',
            title: '3',
            by: 'Lori Hart',
            alt: 'Loop Donut',
        },
        {
            text: 'Accessible on AR.',
            imageSrc: 'images/carousel/crs-4.jpg',
            title: '4',
            by: 'Artist Name',
            alt: 'Accessible AR',
        },

    ];

    const spans = items.map(item => item.text);

    const carouselOptions = {
        infinite: true,
        speed: 300,
        items: 3,
        loop: true,
        margin: 20,
        nav: false,
        dots: false,
        autoplay: true,
        startPosition: activeIndex,
        className: "owl-theme",
        slideBy: 3,

    };
    return (
        <div id="wrapper">
            {/* Header component */}
            <Header />

            <div class="no-bottom wl" id="content">
                <div id="top"></div>
                <section id="section-hero" class="no-top no-bottom mt0 sm-mt-0" aria-label="section">
                    <div class="m-3 padding30 br-15">
                        <div class="container">
                            <div class="row align-items-center">
                                <div class="col-lg-6 mb-sm-30">
                                    <div class="AuthorLink_wrapper__s6RBU AuthorLink_medium__73M_I InfoHeaderCard_authorLinkWrapper__ElGrf">
                                        <p style={{ color: 'rgb(105, 105, 105)', paddingTop: '7px' }}>Created by</p><div class="AuthorLink_profileWrapper__qLZTs AuthorLink_default-color__EVfKq">
                                            <img alt="avatar" loading="lazy" width="86" height="86" decoding="async" data-nimg="1" class="Avatar_avatar__R4GZY AuthorLink_avatar__XdtY7 Avatar_small__a5Mi9" src="/images/author/author-11.jpg" /><p class="Text_h6__CxsoU Text_default__Np3OB AuthorLink_name__yWWGy">
                                                <a href="/profile">@sheidlina</a>
                                        </p><span class="verified"></span></div></div>
                                    <h1>Resistence</h1>
                                    <p class="lead">
                                        Work by Andei Yakovenko — artist and illustrator is known to hundreds of millions of users on Telegram and VKontakte. His distinctive visual style has become instantly recognizable and meaningful to many users.
                                    </p>
                                    <div style={{ display: 'inline-block', marginRight:'100px', verticalAlign: '-webkit-baseline-middle' }}>
                                        <span class="d-title">CURRENT PRICE</span>
                                        <h3>2.59 TON <span >($8935,37)</span></h3>
                                    </div>
                                    <a href="/item" class="ctasm">View artwork <span style={{ marginLeft: '20px' }} aria-hidden="true" class="arrow_right"></span></a>                                    
                                </div>

                                <div class="col-lg-6">
                                    <div class="d-carousel">
                                        <div id="item-carousel-big-type-2" class="owl-carousel owl-center" data-wow-delay="1s">
                                            <div class="nft_pic mod-b br-15">
                                            <a href="/item">
                                            <span class="nft_pic_info">
                                                        <span class="nft_pic_title">Blue Nomad</span>
                                                        <span class="nft_pic_by">Mamie Barnett</span>
                                                    </span>

                                                    <div class="nft_pic_wrap">
                                                        <img src="https://img-cdn.magiceden.dev/rs:fill:800:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fhc%252BnPcLmWxs%252FDW99DlBQ42k40ZoyYV5jCIms5qHjwvvm7D%252B9mGCiFz1Tzvo1bf7rZ0v4njEevqg1t7tEd9ml69ijBwbmdhVeeIzoBtEK7ZzaMYVy0A%252FjkuCMyGmsFgIdVVqW5bigTwaaf0rlc7aRU63CYzquXWpASPw3YCKljlzytlCkjpLPhu7iQQ%252F6zAeM" class="lazy img-fluid" alt="" />
                                                    </div>
                                                </a>
                                            </div>

                                            {/* <div class="nft_pic mod-b br-15">
                                            <a href="/item">
                                            <span class="nft_pic_info">
                                                        <span class="nft_pic_title">Cytotoxin</span>
                                                        <span class="nft_pic_by">Monica Lucas</span>
                                                    </span>

                                                    <div class="nft_pic_wrap">
                                                        <img src="https://madebydesignesia.com/themes/gigaland/images/carousel/crs-12.jpg" class="lazy img-fluid" alt="" />
                                                    </div>
                                                </a>
                                            </div>
                                            <div class="nft_pic mod-b br-15">
                                                <a href="/item">
                                                    <span class="nft_pic_info">
                                                        <span class="nft_pic_title">Manganite</span>
                                                        <span class="nft_pic_by">Fred Ryan</span>
                                                    </span>

                                                    <div class="nft_pic_wrap">
                                                        <img src="images/carousel/crs-17.jpg" class="lazy img-fluid" alt="" />
                                                    </div>
                                                </a>
                                            </div>


                                            <div class="nft_pic mod-b br-15">
                                            <a href="/item">
                                            <span class="nft_pic_info">
                                                        <span class="nft_pic_title">Elutriator</span>
                                                        <span class="nft_pic_by">Lori Hart</span>
                                                    </span>

                                                    <div class="nft_pic_wrap">
                                                        <img src="images/carousel/crs-15.jpg" class="lazy img-fluid" alt="" />
                                                    </div>
                                                </a>
                                            </div>

                                            <div class="nft_pic mod-b br-15">
                                            <a href="/item">
                                            <span class="nft_pic_info">
                                                        <span class="nft_pic_title">Forest Women</span>
                                                        <span class="nft_pic_by">Fred Ryan</span>
                                                    </span>

                                                    <div class="nft_pic_wrap">
                                                        <img src="images/carousel/crs-14.jpg" class="lazy img-fluid" alt="" />
                                                    </div>
                                                </a>
                                            </div> */}

                                        </div>
                                        <div class="d-arrow-left mod-a"><i class="fa fa-angle-left"></i></div>
                                        <div class="d-arrow-right mod-a"><i class="fa fa-angle-right"></i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="section-intro" class="no-bottom pt40" style={{ borderBottom: "1px solid rgba(200, 200, 200, 0.5)" }}>
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <h1>Curated collections</h1>
                                <h6>No collection yet.</h6>
                            </div>
                        </div>
                    </div>
                </section>


                <section id="section-latest-nft" class="no-bottom pt40" style={{ borderBottom: "1px solid rgba(200, 200, 200, 0.5)" }}>
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <h1>Artists</h1>
                                <h6>No artists yet.</h6>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="section-latest-nft" class="no-bottom pt40" style={{ borderBottom: "1px solid rgba(200, 200, 200, 0.5)" }}>
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <h1>Artworks
                                </h1>
                                <h6>No artworks yet.</h6>

                            </div>
                        </div>
                    </div>
                </section>
                <section id="section-news" class="no-bottom pt40">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="text-left pb30">
                                    <h1>Our exhibitions</h1>
                                    <h6>No exhibitions yet.</h6>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 mb-sm-30">
                                <div class="bloglist item">
                                    <div class="post-content">
                                        <div className="post-image-wl">
                                            <img
                                                alt=""
                                                src="https://mostra-mi.it/wp-content/uploads/mostre-novembre-1024x1024.jpg"
                                                className="lazy normal-image"
                                                height=""
                                            />
                                           
                                        </div>
                                        {/* <div class="post-text">
                                            <span class="p-date">October 28, 2020</span>
                                            <h4><a href="news-single.html" class="inactive">Get started with your gallery<span></span></a></h4>
                                            <p>Galleries of all sizes can showcase their collections, reach a global audience, and sell pieces directly to art lovers worldwide.</p>
                                        </div> */}
                                    </div>
                                </div>
                            </div>



                            <div class="col-lg-4 col-md-6 mb-sm-30">
                                <div class="bloglist item">
                                    <div class="post-content">
                                        <div className="post-image-wl">
                                            <img alt="" src="https://mostra-mi.it/wp-content/uploads/post-social-call-artistiche-autunnali-1-1024x1024.jpeg" className="lazy normal-image"
                                                height=""
                                            />
                                          
                                        </div>
                                        {/* <div class="post-text">
                                            <span class="p-date">October 28, 2020</span>
                                            <h4><a href="news-single.html" class="inactive">Grow as an artist<span></span></a></h4>
                                            <p>Artists can share their vision, display their works, and connect with a community of collectors and enthusiasts who truly value creativity and originality..</p>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 mb-sm-30">
                                <div class="bloglist item">
                                    <div class="post-content">
                                        <div className="post-image-wl">
                                        <img alt="" src="https://mostra-mi.it/wp-content/uploads/post-social-mostre-in-ottobre-1024x1024.jpeg" className="lazy normal-image"
                                                height="auto"
                                            />
                                            
                                        </div>
                                        {/* <div class="post-text">
                                            <span class="p-date">October 28, 2020</span>
                                            <h4><a href="news-single.html" class="inactive">Build your collection<span></span></a></h4>
                                            <p>Collectors can explore exclusive pieces, discover emerging artists, and purchase unique artworks that resonate on a personal level, enriching their collections..</p>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="section-intro" class="no-bottom pt80">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12 text-center">
                                <h1 style={{ color: 'gray' }}>Sei un artista emergente? <a href="/contact" style={{ color: '#000' }}>
                                Scopri come partecipare</a></h1>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <div class="modal fade" id="buy_now" tabindex="-1" aria-labelledby="buy_now" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered de-modal">
                    <div class="modal-content">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        <div class="modal-body">
                            <div class="p-3 form-border">
                                <h3>Checkout</h3>
                                You are about to purchase a <b>Diminishable #108</b> from <b>Monica Lucas</b>
                                <div class="spacer-single"></div>
                                <h6>Enter quantity. <span class="id-color-2">10 available</span></h6>
                                <input type="text" name="buy_now_qty" id="buy_now_qty" class="form-control" value="1" />
                                <div class="spacer-single"></div>
                                <div class="de-flex">
                                    <div>Your balance</div>
                                    <div><b>10.67856 ETH</b></div>
                                </div>
                                <div class="de-flex">
                                    <div>Service fee 2.5%</div>
                                    <div><b>0.00325 ETH</b></div>
                                </div>
                                <div class="de-flex">
                                    <div>You will pay</div>
                                    <div><b>0.013325 ETH</b></div>
                                </div>
                                <div class="spacer-single"></div>
                                <a href="wallet.html" target="_blank" class="btn-main btn-fullwidth">Add funds</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="place_a_bid" tabindex="-1" aria-labelledby="place_a_bid" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered de-modal">
                    <div class="modal-content">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        <div class="modal-body">
                            <div class="p-3 form-border">
                                <h3>Place a Bid</h3>
                                You are about to place a bid for <b>Diminishable #108</b> from <b>Monica Lucas</b>
                                <div class="spacer-single"></div>
                                <h6>Your bid (ETH)</h6>
                                <input type="text" name="bid_value" id="bid_value" class="form-control" placeholder="Enter bid" />
                                <div class="spacer-single"></div>
                                <h6>Enter quantity. <span class="id-color-2">10 available</span></h6>
                                <input type="text" name="bid_qty" id="bid_qty" class="form-control" value="1" />
                                <div class="spacer-single"></div>
                                <div class="de-flex">
                                    <div>Your bidding balance</div>
                                    <div><b>0.013325 ETH</b></div>
                                </div>
                                <div class="de-flex">
                                    <div>Your balance</div>
                                    <div><b>10.67856 ETH</b></div>
                                </div>
                                <div class="de-flex">
                                    <div>Service fee 2.5%</div>
                                    <div><b>0.00325 ETH</b></div>
                                </div>
                                <div class="de-flex">
                                    <div>You will pay</div>
                                    <div><b>0.013325 ETH</b></div>
                                </div>
                                <div class="spacer-single"></div>
                                <a href="wallet.html" target="_blank" class="btn-main btn-fullwidth">Place a bid</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer component */}
            <FooterWL />


        </div >
    );
}

export default HomeGalleryWL;